angular.module('unica_invitation_room.invitation_room_services')

.factory('InvitationRoomEditService', function ($http, getBaseApiURL) {

	var invitationRoomEditService = {};

	invitationRoomEditService.update = function (invitationRoomData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-room/update/' + invitationRoomData.id,
			data: invitationRoomData
		}).then(function(result) {

			if ( result ) {
				return result.data.invitation_room;
			}

		});

	};

	invitationRoomEditService.sendNotifications = function ( invitationRoomData ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/invitation-room/send-notifications',
			data: invitationRoomData
		}).then(function(result) {

			if ( result ) {
				return result.data;
			}

		});

	};

	return invitationRoomEditService;
});